export let handleUnauthorizedError = () => {};

export const setUnauthorizedErrorHandler = (callback) => {
  handleUnauthorizedError = callback;
};
